module.exports = __webpack_public_path__ + "img/mascot-print-page.38ab023f.svg";